import * as ActionTypes from '../ActionTypes';


export const GetAIConfigAction = (params, callback) => ({
    type: ActionTypes.GET_AI_CONFIG_REQUEST,
    params,
    callback
});

export const AddAIConfigAction = (params) => ({
    type: ActionTypes.ADD_AI_CONFIG_REQUEST,
    params,
});

export const UpdateAIConfigAction = (params) => ({
    type: ActionTypes.UPDATE_AI_CONFIG_REQUEST,
    params,
});

export const DeleteAIConfigAction = (params) => ({
    type: ActionTypes.DELETE_AI_CONFIG_REQUEST,
    params,
});

export const TestModelAction = (params, callback) => ({
    type: ActionTypes.TEST_MODEL_REQUEST,
    params,
    callback
});

